import type { FrontendDataUpdateKeys } from '@peanuds/shared';

type SocketEventMap<TPayloads extends object> = {
  [TEvent in keyof TPayloads]: (payload: TPayloads[TEvent]) => void;
};

type SocketEventPayloads<TEvents extends Record<string, (...args: never[]) => unknown>> = {
  [TEvent in keyof TEvents]: Parameters<TEvents[TEvent]>[0];
};

export const refetchKeys = {
  KYC_STATUS: 'KYC_STATUS',
  KYB_STATUS: 'KYB_STATUS',
  AUTH_JWT: 'AUTH_JWT',
  CHALLENGE_CONSUMED: 'CHALLENGE_CONSUMED',
  ACCOUNTS: 'ACCOUNTS',
  INCOMING_TRANSFER: 'INCOMING_TRANSFER',
  EXCHANGE: 'EXCHANGE',
  OUTGOING_TRANSFERS: 'OUTGOING_TRANSFERS',
  GENERIC_TRANSACTION: 'GENERIC_TRANSACTION',
  PAYMENT_BATCHES: 'PAYMENT_BATCHES',
  ORGANIZATION_MEMBERS: 'ORGANIZATION_MEMBERS',
  REPORTS: 'REPORTS',
  SDD_CREDITOR_ID_STATUS: 'SDD_CREDITOR_ID_STATUS',
} as const satisfies Record<FrontendDataUpdateKeys, FrontendDataUpdateKeys>;

export type RefetchKey = (typeof refetchKeys)[keyof typeof refetchKeys];

export interface StaleDataUpdatePayload {
  refetchKeys?: unknown[];
  itemIds?: unknown[];
}

export interface ClientDataUpdatedPayload {
  type?: 'client_data_updated';
  ts?: string;
  correlationId?: string;
  data?: {
    userId?: string;
    refetchKeys?: unknown[];
    itemIds?: unknown[];
  };
}

export type StaleDataEventPayload = StaleDataUpdatePayload | ClientDataUpdatedPayload;

export interface ServerToClientEventPayloads {
  stale_data_update: StaleDataUpdatePayload;
  client_data_updated: ClientDataUpdatedPayload;
}

/** Server → Client events. Keys must match the socket.io event names from the server. */
export type ServerToClientEvents = SocketEventMap<ServerToClientEventPayloads>;

/** Client → Server events. */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ClientToServerEvents {}

/** Extract the payload type for a given server event. */
export type ServerEventPayload<E extends keyof ServerToClientEvents> =
  SocketEventPayloads<ServerToClientEvents>[E];
